const state = {
    equipments: [],
    documents: [],
    file: null,
    loading: false,
    docLoader: false
};

export default state;